import React from "react";

const variantStyles = {
  normal: {
    wrapper: "bg-slate-900 text-slate-100",
    title: "Notification",
    button: "bg-slate-100 text-slate-900 hover:bg-slate-200",
  },
  success: {
    wrapper: "bg-emerald-900 text-emerald-100",
    title: "Success",
    button: "bg-emerald-500 text-white hover:bg-emerald-400",
  },
  error: {
    wrapper: "bg-rose-900 text-rose-100",
    title: "Error",
    button: "bg-rose-500 text-white hover:bg-rose-400",
  },
  warning: {
    wrapper: "bg-amber-900 text-amber-100",
    title: "Warning",
    button: "bg-amber-500 text-white hover:bg-amber-400",
  },
};

const SimpleMessageModal = ({ message = "", show, onClose, variant = "normal", title = "" }) => {
    if (!show) return null;

    const current = variantStyles[variant] || variantStyles.normal;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm p-4">
            <div className={`rounded-2xl shadow-2xl max-w-md w-full p-6 relative ${current.wrapper}`}>
                <h2 className="text-lg font-semibold mb-4">{title || current.title}</h2>
                <p className="text-sm whitespace-pre-line mb-6">{message}</p>
                <button
                    onClick={onClose}
                    className={`w-full py-3 rounded-lg font-semibold transition ${current.button}`}
                    aria-label="Close notification"
                >
                    OK
                </button>
            </div>
        </div>
    );
};

export default SimpleMessageModal;
